/**
 * @generated SignedSource<<130fd6cac3531b77f7ce38cd9ad17c3a>>
 * @relayHash 7d704d287ff0bcf18473f7cf2715a951
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f17ee486bf362a964561e928ff6412a8fc0fbd34d123871296965aab2ac397f4

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentOverviewInternalsQuery$variables = {
  helpCenterAri: string;
};
export type AgentOverviewInternalsQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianCsmAgentOverview" | "agentIdentity_AtlassianCsmAgentIdentity_agentRef">;
    } | null | undefined;
  } | null | undefined;
};
export type AgentOverviewInternalsQuery = {
  response: AgentOverviewInternalsQuery$data;
  variables: AgentOverviewInternalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "agentCard_AtlassianCsmAgentOverview"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "agentIdentity_AtlassianCsmAgentIdentity_agentRef"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "companyName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "companyDescription"
                      },
                      {
                        "concreteType": "CsmAiAgentTone",
                        "kind": "LinkedField",
                        "name": "tone",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "greetingMessage"
                      },
                      {
                        "concreteType": "CsmAiAgentConversationStarter",
                        "kind": "LinkedField",
                        "name": "conversationStarters",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "message"
                          },
                          (v3/*: any*/)
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f17ee486bf362a964561e928ff6412a8fc0fbd34d123871296965aab2ac397f4",
    "metadata": {},
    "name": "AgentOverviewInternalsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "59475ce8e940cff6df03117223825728";

export default node;
